import {
    EntryModel,
    PreparedDataOnEntryUpdate,
} from '../../../../types/Entries';
import { DBWriterLoggerFunction } from '../../../../types/logger';
import { toPreparedDataItems } from './common';

const prepareBumpEntries = async ({
    ids,
    getByID,
}: {
    ids: string[];
    getByID: (id: string) => Promise<EntryModel>;
}) => {
    const entryElements = await Promise.all(ids.map(async (id) => getByID(id)));

    return { entryElements };
};

const prepareBumpEntryUpdates = (entryElements: EntryModel[]) => {
    return entryElements.map((entryElement: EntryModel) =>
        entryElement.prepareUpdate((entry: EntryModel) => {
            entry.title = entryElement.title;
        }),
    );
};

const appendPreparedEntries = (
    preparedData: PreparedDataOnEntryUpdate[],
    bumpData: { entriesToUpdate: EntryModel[] },
) => {
    return [
        ...preparedData,
        ...toPreparedDataItems(bumpData.entriesToUpdate, 'entries', 'update'),
    ];
};

const logBumpDBActions = ({
    entriesToUpdate,
    logDBAction,
    tableName,
}: {
    entriesToUpdate: EntryModel[];
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Entries bump',
        modelName: tableName,
        payload: entriesToUpdate,
    });
};

export {
    appendPreparedEntries,
    logBumpDBActions,
    prepareBumpEntries,
    prepareBumpEntryUpdates,
};
